export { emptySlot, type StreamSlot } from "./slot-fields";

export type CommonOptions = { memberOnlyLabel?: string };

export type Profile = { artist_handle: string };

export const emptyProfile: Profile = { artist_handle: "" };
